<button mat-icon-button [matMenuTriggerFor]="menu" class="more-actions" (click)="loadActions()">
  <mat-icon>more_horiz</mat-icon>
</button>
<mat-menu #menu="matMenu">
  <button mat-menu-item *ngIf="loadingActions; else actionsTemplate">
    <div>
      <span translate="user-interaction/loading"></span>
      &#x2026;<!-- Horizontal Ellipsis (...) -->
    </div>
  </button>
  <ng-template #actionsTemplate>
    <ng-container *ngIf="taskActionsList?.length || messageActionsList?.length; else noResults">
      <ng-container *ngFor="let taskAction of taskActionsList">
        <button mat-menu-item (click)="taskAction.onClick()">
          <span>{{ taskAction.text }}</span>
        </button>
      </ng-container>

      <ng-container *ngFor="let messageAction of messageActionsList">
        <button mat-menu-item (click)="doMessageAction(messageAction.action_type)">
          <span>{{ messageAction.text }}</span>
        </button>
      </ng-container>
    </ng-container>

    <ng-template #noResults>
      <button mat-menu-item>
        <span translate="message_action/none"></span>
      </button>
    </ng-template>
  </ng-template>
</mat-menu>
